import { Button, Col, Input, Modal, Row, Upload, Typography } from "antd";
import { useEffect, useState } from "react";
import { MetadataTable } from "../../upload-page/sub-components/metadata-table";
import {
  ContainerData,
  MetadataCollection,
  MetadataItem,
  MetadataRowItem,
  MetadataTemplateItem,
} from "../../../api/data-types";
import { StorageAPIClient } from "../../../api/storage-api-client";

import { File } from "../../../api/data-types";

import "./metadata-preview.css";
import { RcFile } from "antd/es/upload";

interface MetadataMassEditModalProps {
  theme: string;
  isOpen: boolean;
  sendStateToParent: () => void;
  selectedContainer: ContainerData;
  selectedFiles: File[];
  closePreview: () => Promise<void>;
}

export const MetadataMassEditModal = ({
  theme,
  isOpen,
  sendStateToParent,
  selectedContainer,
  selectedFiles,
  closePreview,
}: MetadataMassEditModalProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);

  const [metadataItems, setMetadataItems] = useState<MetadataRowItem[]>([]);

  const [countMetadata, setCountMetadata] = useState<number>(0);

  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const [metadataCheck, setMetadataCheck] = useState<boolean>(true);

  const [failedFiles, setFailedFiles] = useState<File[]>([]);

  const [updateDone, setUpdateDone] = useState<boolean>(false);

  const handleAddMetadataItem = () => {
    setMetadataItems([
      ...metadataItems,
      new MetadataRowItem("", "", countMetadata),
    ]);
    setCountMetadata(countMetadata + 1);
  };

  const handleAddMetadataTemplate = (file: RcFile) => {
    let tmpMetadataTable: MetadataRowItem[] = [];
    let counter: number = 1;
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileAsString = e.target?.result as string;
      if (fileAsString !== null) {
        try {
          const JSONfile = JSON.parse(fileAsString);
          for (const [key, value] of Object.entries(JSONfile)) {
            if (typeof value === "string") {
              tmpMetadataTable = [
                ...tmpMetadataTable,
                new MetadataRowItem(key, value, countMetadata + counter),
              ];
              counter += 1;
            } else {
              tmpMetadataTable = [
                ...tmpMetadataTable,
                new MetadataRowItem(key, "", countMetadata + counter),
              ];
              counter += 1;
            }
          }
        } catch (error) {
          if (error instanceof Error) {
            setErrorMessage(error.message);
          } else {
            setErrorMessage("An unexpected error occurred.");
          }
        }
        for (let i = 0; i < selectedContainer.metadataTemplate.length; i++) {
          let index = tmpMetadataTable
            .map((item) => item.item.key)
            .indexOf(selectedContainer.metadataTemplate[i].key);
          if (index !== -1) {
            tmpMetadataTable[index].itemTemplate =
              selectedContainer.metadataTemplate[i];
            if (tmpMetadataTable[index].itemTemplate.readOnly) {
              tmpMetadataTable[index].item.value =
                tmpMetadataTable[index].itemTemplate.defaultValue;
            }
          }
        }
        setMetadataItems(tmpMetadataTable);
        setCountMetadata(countMetadata + counter);
      }
    };
    reader.readAsText(file);
    return false;
  };

  const handleRemoveMetadataItem = (key: number) => {
    const updatedData = metadataItems.filter(
      (item) => metadataItems.indexOf(item) !== key
    );
    setMetadataItems(updatedData);
  };

  const handleItemChange = (key: number, metadataItem: MetadataRowItem) => {
    let tmpMetadataItems: MetadataRowItem[] = Object.assign([], metadataItems);
    tmpMetadataItems[key] = metadataItem;
    setMetadataItems(tmpMetadataItems);
  };

  const resetMetadata = () => {
    setMetadataItems([new MetadataRowItem("", "", countMetadata)]);
    setCountMetadata(countMetadata + 1);
  };

  const handleMetadatatemplateError = () => {
    setMetadataCheck(true);
    setErrorMessage(undefined);
    resetMetadata();
    setLoading(false);
    setUpdateDone(false);
  };

  const handleMetadataCheckError = () => {
    setMetadataCheck(true);
    setErrorMessage(undefined);
    setUpdateDone(false);
  };

  const handleUpdateFinished = async () => {
    setFailedFiles([]);
    setMetadataCheck(true);
    setErrorMessage(undefined);
    setIsVisible(false);
    sendStateToParent();
    setLoading(false);
    setUpdateDone(false);
    await closePreview();
  };

  async function onFinish() {
    let tmpMetadataTable: MetadataRowItem[] = metadataItems;
    let errorList: File[] = [];
    for (let i = 0; i < selectedContainer.metadataTemplate.length; i++) {
      let index = tmpMetadataTable
        .map((item) => item.item.key)
        .indexOf(selectedContainer.metadataTemplate[i].key);
      if (index !== -1) {
        tmpMetadataTable[index].itemTemplate =
          selectedContainer.metadataTemplate[i];
      }
    }
    let tmpMetadataItems: MetadataItem[] = [];
    let tmpMetadataCheck: boolean = true;
    let item: MetadataItem;
    setMetadataCheck(true);
    for (let i = 0; i < tmpMetadataTable.length; i++) {
      if (
        tmpMetadataTable[i].item.key !== "" &&
        tmpMetadataTable[i].item.key.trim() !== ""
      ) {
        if (!tmpMetadataTable[i].item.isIndexed) {
          if (
            !tmpMetadataTable[i].itemTemplate.fromConfiguration ||
            !tmpMetadataTable[i].itemTemplate.required
          ) {
            item = tmpMetadataTable[i].item;
            item.value = "";
            tmpMetadataItems = [...tmpMetadataItems, item];
          }
        } else if (
          tmpMetadataTable[i].item.value !== "" &&
          tmpMetadataTable[i].item.value.trim() !== "" &&
          (!tmpMetadataTable[i].itemTemplate.fromConfiguration ||
            !tmpMetadataTable[i].itemTemplate.readOnly)
        ) {
          if (
            !tmpMetadataTable[i].itemTemplate.fromConfiguration ||
            !tmpMetadataTable[i].itemTemplate.readOnly
          ) {
            item = tmpMetadataTable[i].item;
            tmpMetadataItems = [...tmpMetadataItems, item];
          }
        }
      } else if (
        (tmpMetadataTable[i].item.key === "" ||
          tmpMetadataTable[i].item.key.trim() === "") &&
        tmpMetadataTable[i].item.value !== "" &&
        tmpMetadataTable[i].item.value.trim() !== ""
      ) {
        tmpMetadataCheck = false;
        break;
      }
    }
    if (!tmpMetadataCheck || tmpMetadataItems.length === 0) {
      if (metadataItems.length === 0) {
        setMetadataCheck(false);
      } else {
        await closePreview();
      }
    } else {
      setLoading(true);
      StorageAPIClient.massUpdateMetadata(
        selectedContainer.containerName,
        selectedFiles,
        tmpMetadataItems
      )
        .then((response) => response.data)
        .then((json) => {
          json.forEach((item: any) => {
            if (item.statusCode !== 200) {
              errorList = [...errorList, item.fileInformation.fileName];
            }
          });
          if (errorList.length !== 0) {
            setFailedFiles(errorList);
          }
          setUpdateDone(true);
          setLoading(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    }
  }

  useEffect(() => {
    setIsVisible(isOpen);
    if (isOpen) {
      resetMetadata();
    }
  }, [isOpen]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <>
      {!metadataCheck && (
        <Modal
          title="Error!"
          onOk={handleMetadataCheckError}
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          open={!metadataCheck}
        >
          <p style={{ color: textColor }} className="modalText">
            Please make sure there are no values without provided keys and that
            you have at least one item in your list.
          </p>
        </Modal>
      )}
      {errorMessage !== undefined && (
        <Modal
          title="Error!"
          onOk={handleMetadatatemplateError}
          okButtonProps={{ style: { color: "black" } }}
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          open={errorMessage !== undefined}
        >
          <p style={{ color: textColor }}>`{errorMessage}`</p>
        </Modal>
      )}
      {failedFiles.length !== 0 && (
        <Modal
          title="Error!"
          onOk={handleUpdateFinished}
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          open={failedFiles.length !== 0}
          style={{ overflow: "auto" }}
        >
          <div style={{ color: textColor }} className="modalText">
            There has been an error in metadata update.<br></br>
            Error in updating: <br></br>
            {failedFiles.map((item, index) => (
              <div key={index}>{item.name}</div>
            ))}
          </div>
        </Modal>
      )}
      {metadataCheck &&
        errorMessage === undefined &&
        failedFiles.length === 0 && (
          <>
            <Modal
              title="Update succesful!"
              onOk={handleUpdateFinished}
              okButtonProps={{ style: { color: "black" } }}
              cancelButtonProps={{ style: { display: "none" } }}
              closable={false}
              open={updateDone}
            >
              <p style={{ color: textColor }}>
                The changes may take a few seconds to apply.
              </p>
            </Modal>
            <Modal
              className="modalEditMetadata"
              open={isVisible}
              closable={false}
              footer={[
                <Button
                  key="cancel"
                  onClick={() => {
                    setIsVisible(false);
                    sendStateToParent();
                  }}
                >
                  Cancel
                </Button>,
                <Button type="primary" key="ok" onClick={onFinish} loading={loading}>
                  Save
                </Button>,
              ]}
            >
              <Col span={24}>
                <Row>
                  <Col span={24} className="metadataTemplateModalButtonColumn">
                    <Upload
                      accept=".json"
                      beforeUpload={handleAddMetadataTemplate}
                      showUploadList={false}
                    >
                      <Button className="metadataTemplateModalButton">
                        Load metadata
                      </Button>
                    </Upload>
                  </Col>
                </Row>
                <Row>
                  <Col
                    span={24}
                    className="metadataColumn"
                    style={{ overflow: "auto" }}
                  >
                    <Row>
                      <MetadataTable
                        isModal={true}
                        theme={theme}
                        metadataItems={metadataItems}
                        handleRemoveMetadataItem={handleRemoveMetadataItem}
                        handleItemChange={handleItemChange}
                        isMassUpdate={true}
                        selectedContainer={selectedContainer}
                      />
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} className="addModalButtonColumn">
                    <Button
                      className="addModalButton"
                      onClick={handleAddMetadataItem}
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Modal>
          </>
        )}
    </>
  );
};
